import { cleanNotifications, showNotification } from "@mantine/notifications";
import { axiosPost } from "../../Helpers";

export const addCategory = async (values, setOpened, setUpdate) => {
  cleanNotifications();
  console.log(values);
  axiosPost("categories/addCategory", values).then((response) => {
    console.log("categories Added", response.data);
    if (!response.data.status) {
      setOpened(false);
      showNotification({
        title: "Error",
        message: `${response.data.message}`,
        color: "red",
      });
    } else {
      setUpdate((prev) => !prev);
      setOpened(false);
      showNotification({
        title: "Success",
        message: `${response.data.message}`,
        color: "green",
      });
    }
  });
};
